<!--
Author: TangChen
Date: 2018-11-26
Desc: 用户持有银行卡信息操作组件，由index.js 配置引入
-->
<template>
    <div class="comp-bank-operation comp">
        <!-- 验证证件信息 -->
        <el-form
            v-if="!checked"
            ref="acctInfo"
            :model="acctInfo"
            :rules="rules"
            label-width="416px"
            class="pwdForm"
            inline-message
            v-on:submit.native.prevent
        >
            <el-form-item label="银行卡户名：" class="form-text">
                <div class="text-con">
                    {{ info.custname }}
                </div>
            </el-form-item>
            <el-form-item label="证件类型：" class="form-text">
                <div class="text-con">
                    {{ $cache.getDict("130007", info.certificatetype) }}
                </div>
            </el-form-item>
            <el-form-item label="证件号码：" class="form-text">
                <div class="text-con">
                    {{ info.certificateno + "（" + info.certificateno.length + "位）" }}
                </div>
            </el-form-item>
            <el-form-item v-if="cate !== 'add'" label="银行卡号码：" class="form-text">
                <div class="text-con">
                    {{ acctInfo.oldBank }}
                </div>
            </el-form-item>
            <el-form-item
                v-if="cate === 'change' || cate === 'add'"
                :label="(cate === 'change' ? '新' : '') + '银行卡号码：'"
                prop="bankcard"
            >
                <div
                    v-show="showBankCard && acctInfo.bankcard !== ''"
                    class="bank-code el-message--warning"
                    :class="{ show: showBankCard && acctInfo.bankcard !== '' }"
                >
                    {{ $util.getNewCard(acctInfo.bankcard) }}
                </div>
                <el-input
                    v-model.trim="acctInfo.bankcard"
                    placeholder="请输入完整银行卡号码"
                    :maxlength="20"
                    clearable
                    v-on:focus="showBankCard = true"
                    v-on:blur="showBankCard = false"
                />
            </el-form-item>
            <el-form-item v-if="cate === 'add'" label="所属银行：" prop="bankType" class="bank">
                <div
                    class="bank-msg"
                    :style="{ opacity: bankInfo.channelid ? 1 : 0 }"
                    v-on:click="bankVisible = !bankVisible"
                >
                    <div
                        v-if="bankInfo.channelid"
                        class="bank-img-sel clear"
                        :class="{ 'bg-w': bankInfo.channelid }"
                    >
                        <img :src="$util.getImg(bankInfo.bankcode)" title="bank-img" alt="" />
                        <span class="k-text-flow">
                            {{
                                bankInfo.bankname.toString().substr(0, 10) +
                                (bankInfo.bankname.toString().length > 10 ? "..." : "")
                            }}
                        </span>
                        <i class="paycenter" aria-hidden="true">
                            {{ bankInfo.paycentername }}
                        </i>
                    </div>
                </div>
                <el-select
                    v-model.trim="acctInfo.bankType"
                    placeholder="请选择"
                    :maxlength="20"
                    suffix-icon="fa fa-money-check"
                    :readonly="true"
                />
            </el-form-item>
            <el-form-item v-else label="所属银行：" class="bank form-text">
                <div class="bank-msg">
                    <div
                        v-if="bankInfo.channelid"
                        class="bank-img-sel clear"
                        :class="{ 'bg-w': bankInfo.channelid }"
                    >
                        <img :src="$util.getImg(bankInfo.bankcode)" title="bank-img" alt="" />
                        <span class="k-text-flow">
                            {{
                                $cache
                                    .getDict("110080", bankInfo.bankcode)
                                    .toString()
                                    .substr(0, 10) +
                                ($cache.getDict("110080", bankInfo.bankcode).toString().length > 10
                                    ? "..."
                                    : "")
                            }}
                        </span>
                        <i class="paycenter" aria-hidden="true">
                            {{
                                $cache
                                    .getDict("110079", bankInfo.paycenterid)
                                    .toString()
                                    .substr(0, 4)
                            }}
                        </i>
                    </div>
                </div>
            </el-form-item>
            <el-form-item
                v-if="
                    (bankInfo.isneedbank === '1' && cate !== 'active') ||
                    (cate === 'modify' && acctInfo.province)
                "
                label="开户行所在省："
                prop="province"
            >
                <el-select v-model="acctInfo.province" filterable placeholder="请选择开户行所在省">
                    <el-option
                        v-for="item in province"
                        :key="item.subitem"
                        :label="item.subitemname"
                        :value="item.subitem"
                    />
                </el-select>
            </el-form-item>
            <el-form-item
                v-if="
                    (bankInfo.isneedbank === '1' || cate === 'modify') &&
                    acctInfo.province !== '' &&
                    cate !== 'active'
                "
                label="开户行所在城市："
                prop="city"
            >
                <el-select v-model="acctInfo.city" filterable placeholder="请选择开户行所在城市">
                    <el-option
                        v-for="item in city"
                        :key="item.cityid"
                        :label="item.cityname"
                        :value="item.cityid"
                    />
                </el-select>
            </el-form-item>
            <el-form-item
                v-if="
                    (bankInfo.isneedbank === '1' || cate === 'modify') &&
                    acctInfo.city !== '' &&
                    !shieldBranchSelect
                "
                label="开户行名称："
                prop="bankname"
                style="position: relative"
                class="form-text-bank"
            >
                <el-autocomplete
                    v-if="inputMode === 1"
                    ref="autocomplete"
                    v-model.trim="acctInfo.bankname"
                    class="inline-input"
                    :fetch-suggestions="querySearch"
                    popper-class="auto-width-select-option"
                    placeholder="请选择开户行"
                    :disabled="cate === 'active'"
                    :maxlength="40"
                    v-on:blur="checkBankName"
                    v-on:focus="clearOption"
                >
                    <el-tooltip
                        slot="suffix"
                        class="item"
                        effect="info"
                        :content="infoText"
                        placement="top"
                    >
                        <el-button class="info-btn">
                            <i class="el-icon-question" aria-hidden="true" />
                        </el-button>
                    </el-tooltip>
                </el-autocomplete>
                <el-input
                    v-if="inputMode === 2"
                    v-model.trim="acctInfo.bankname"
                    placeholder="请输入开户行名称"
                    :maxlength="40"
                />
                <div class="append-info">
                    <span v-if="inputMode === 1">
                        未找到？
                        <a v-on:click="changeInputMode(2)">手动输入</a>
                    </span>
                    <span v-if="inputMode === 2">
                        <a v-on:click="changeInputMode(1)">返回</a>
                    </span>
                </div>
            </el-form-item>
            <el-form-item
                v-if="cate !== 'add' && !emptyMobile"
                label="银行预留手机号："
                class="form-text"
            >
                <div class="text-con">
                    <span>{{ acctInfo.mobileno }}</span>
                    <div v-if="cate !== 'active'" class="other-prompt">
                        <i class="el-icon-warning" aria-hidden="true" />
                        <span>不是该银行卡的预留手机号码？</span>
                        <span class="like-a" v-on:click="changeMobile = !changeMobile">
                            {{ changeMobile ? "放弃" : "" }}修改手机号码
                        </span>
                    </div>
                </div>
            </el-form-item>
            <el-form-item
                v-if="changeMobile || (emptyMobile && cate !== 'modify')"
                :label="(changeMobile ? '新' : '银行预留') + '手机号码：'"
                prop="newMobile"
            >
                <el-input
                    v-model.trim="acctInfo.newMobile"
                    placeholder="请输入银行预留手机号码"
                    :maxlength="11"
                />
            </el-form-item>
            <el-form-item v-if="isPwdCheck" label="基金交易密码：" prop="tradepwd">
                <el-input
                    v-model.trim="acctInfo.tradepwd"
                    type="password"
                    placeholder="请输入基金交易密码"
                    :maxlength="16"
                />
                <span class="redemp-btn" v-on:click.prevent="$router.push({ name: 'tradepwd' })">
                    <span class="like-a">忘记密码？</span>
                </span>
            </el-form-item>
            <!-- 转账交易开关：仅新版 DC 多交易账号且 A02 开启时展示 -->
            <div v-if="showTransferTradeSwitch" class="el-form-item transfer-trade-item">
                <label class="el-form-item__label transferTradeSwitch">
                    开通转账交易
                    <el-tooltip
                        class="item"
                        effect="info"
                        :content="transferTradeTip"
                        placement="top"
                    >
                        <el-button class="question-trigger">
                            <i class="el-icon-question question-icon" aria-hidden="true" />
                        </el-button>
                    </el-tooltip>
                    ：
                </label>
                <div class="el-form-item__content transferTradeSwitch-content">
                    <div class="el-input el-input--suffix transferTradeSwitch-switch">
                        <el-switch
                            v-model="acctInfo.addhkflag"
                            active-color="var(--color-primary)"
                            active-value="1"
                            inactive-value="0"
                        />
                    </div>
                </div>
            </div>
            <!-- <el-form-item
                v-if="
                    cate !== 'modify' &&
                    bankInfo &&
                    bankInfo.identifytype === '1'
                "
                label="验证码："
                prop="verifyCode"
                :class="{ 'form-text': !isPwdCheck }"
            >
                <el-input
                    v-model.trim="acctInfo.verifyCode"
                    placeholder="请输入手机验证码"
                    :maxlength="6"
                >
                    <el-button
                        slot="append"
                        class="get-verify"
                        :disabled="time > 0"
                        v-on:click="mobileCheck"
                    >
                        {{ btnMsg }}
                    </el-button>
                </el-input>
            </el-form-item> -->
            <el-form-item>
                <agreement
                    ref="agreeRef"
                    v-model="protocol"
                    :data="argtype"
                    :exclude-policy-types="agreementExcludePolicyTypes"
                    v-on:all-read="agreePro"
                ></agreement>
            </el-form-item>
            <el-form-item>
                <div class="warm-tip">
                    <i class="el-icon-warning" aria-hidden="true" />
                    温馨提示：此手机号为您在银行预留的号码，请确认能正常接收短信
                </div>
            </el-form-item>
            <el-form-item>
                <div style="width: 50%; margin-left: 100px">
                    <button class="next-btn" v-on:click="mobileCheck">下一步</button>
                    <!-- <el-button class="medium" v-on:click="$router.back()">
                        返回
                    </el-button> -->
                </div>
            </el-form-item>
        </el-form>
        <bank-lists
            :cert-type="$cache.getUser().certificatetype"
            :bank-visible="bankVisible"
            v-on:bank-hide="getBankMsg"
        />
        <result
            v-if="checked"
            :result="result"
            v-on:login-now="$router.push({ name: 'fund' })"
            v-on:return-login="$router.push({ name: 'acctManager', query: { activeIndex: '4-1' } })"
        />
        <img-code :dialog-visible="dialogVisible" v-on:verify-in="getVerifyCode" />
        <mobile-code
            :mobile-visible="mobileVisible"
            :mobile-no="acctInfo.newMobile ? acctInfo.newMobile : acctInfo.mobileno"
            v-on:verify-in="getMobileCode"
        />
    </div>
</template>
<script>
import bankLists from "@/components/form/bankListsDc.vue";
import result from "@/components/layout/resultDc.vue";
import agreement from "@/components/form/agreement.vue";
import imgCode from "@/components/layout/imgCode.vue";
import mobileCode from "@/components/layout/mobileCodeDc.vue";
import userApi from "@/api/user";
import { policyTypesEnum, sceneEnum } from "@/util/util_jfit";

export default {
    name: "BankOperation",
    components: {
        bankLists,
        result,
        agreement,
        mobileCode,
        imgCode
    },
    props: {
        cate: {
            type: String,
            default: "add"
        },
        fn: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            argtype: sceneEnum.addBankCard,
            randomToken: "",
            dialogVisible: false,
            mobileVisible: false,
            showBankCard: false, // 是否着重显示银行卡号码
            province: [], // 省
            city: [], // 城市
            acctInfo: {
                // 表单参数配置
                bankType: "",
                bankcard: "",
                mobileno: "",
                newMobile: "",
                province: "",
                city: "",
                addhkflag: "0",
                bankname: "",
                verifyCode: "",
                tradepwd: ""
            },
            emptyMobile: true,
            cateText: "",
            result: {
                // 结果页面信息
                cla: "register-success",
                msg: "您的银行卡已添加成功！",
                btnMsg: "您新增的银行卡为：民生银行（通联）尾号[1234]",
                btnL: {
                    text: "查看我的银行卡",
                    event: "return-login"
                },
                btnR: {
                    text: "去购买基金",
                    event: "login-now"
                }
            },
            bankCate: "",
            infoText: "如果下拉选项中及搜索结果中没有您的开户行，请选择附近的开户行",
            query: null, // 定时查找
            btnMsg: "获取短信验证码",
            time: 0, // 验证码再次发送间隔
            oldBankInfo: {}, // 保存旧银行卡信息
            isPwdCheck: false, // 是否校验密码
            checked: false,
            changeMobile: false,
            bankVisible: false, // 是否弹出银行卡列表
            info: {},
            locked: false, // 是否已发送短信
            isCheckVerifyCode: true,
            branchList: [],
            protocol: false,
            protocolPassed: false, // 协议是否已阅读并同意
            rules: {
                // 校验规则
                bankType: [
                    {
                        required: true,
                        message: "请选择所属银行",
                        trigger: "blur"
                    }
                ],
                bankcard: [
                    {
                        required: true,
                        message: "请输入银行卡号码",
                        trigger: "blur"
                    },
                    { validator: this.$util.validateBankNum, trigger: "blur" }
                ],
                mobileno: [
                    {
                        required: true,
                        message: "请输入银行预留手机号码",
                        trigger: "blur"
                    },
                    { validator: this.$util.validateMobile, trigger: "blur" }
                ],
                newMobile: [
                    {
                        required: true,
                        message: "请输入银行预留手机号码",
                        trigger: "blur"
                    },
                    { validator: this.checkMobile, trigger: "blur" }
                ],
                province: [
                    {
                        required: true,
                        message: "请输入开户省",
                        trigger: "change"
                    }
                ],
                city: [
                    {
                        required: true,
                        message: "请输入开户市",
                        trigger: "change"
                    }
                ],
                bankname: [{ validator: this.validateBankname, trigger: "change" }],
                tradepwd: [
                    {
                        required: true,
                        message: "请输入交易密码",
                        trigger: "blur"
                    }
                ],
                verifyCode: [{ validator: this.validateVerifyCode, trigger: "blur" }]
            },
            bankInfo: {},
            timer: null,
            inputMode: 1, // 1-下拉选项  2-手动输入
            shieldBranchSelect: false
        };
    },
    computed: {
        // 多交易账号模式且 A02 开启时，增卡页展示转账交易开关
        showTransferTradeSwitch() {
            return (
                this.cate === "add" &&
                this.$cache.getSysParam("10113006") === "2" &&
                this.$util.remitOpen()
            );
        },
        transferTradeTip() {
            const companyShortName =
                this.$cache.getCompanyInfoParam("10101014") ||
                this.$cache.getCompanyInfoParam("10101001") ||
                "基金公司";
            return `本功能支持您在${companyShortName}线上提交基金认购/申购申请后，主动将购买资金汇款至${companyShortName}指定收款账户，以完成基金交易。`;
        },
        // 开关打开时保留 M 类协议，关闭或不展示时过滤 M 类协议
        agreementExcludePolicyTypes() {
            return this.showTransferTradeSwitch && this.acctInfo.addhkflag === "1"
                ? []
                : [policyTypesEnum.transfer];
        }
    },
    watch: {
        "acctInfo.province"(val) {
            const _this = this;
            // 城市查询
            const _p = _this.province.find((item) => {
                return item.subitem === val;
            });
            this.$util.getCity(_p.subitem, (data) => {
                _this.city = data || [];
                let _cityObj = {};
                let _city = "";
                // 城市查询结果是否存在
                if (_this.city.length > 0) {
                    // 是否存在旧的城市选项
                    if (_this.oldBankInfo.city && _this.oldBankInfo.province === val) {
                        _cityObj = _this.city.find((item) => {
                            return (
                                item.cityname === _this.oldBankInfo.city ||
                                item.cityid === _this.oldBankInfo.city
                            );
                        });
                        _this.oldBankInfo.city = _cityObj.cityid || "";
                    }
                    _city = _cityObj.cityid || _this.city[0].cityid;
                }
                _this.$set(_this.acctInfo, "city", _city || "");
                _this.$set(_this.acctInfo, "bankname", "");
            });
        },
        "acctInfo.city"(val) {
            this.acctInfo.bankname = "";
            this.clearOption();
            if (!val) return;
            if (this.oldBankInfo.city === this.acctInfo.city && this.oldBankInfo.name) {
                let cityObj = this.city.find((item) => {
                    return item.cityid === this.acctInfo.city;
                });
                this.acctInfo.cityName = cityObj.cityname;
                this.$util.querySearch(this, this.oldBankInfo.name, this.bankInfo.bankcode);
                this.$set(
                    this.acctInfo,
                    "bankname",
                    this.oldBankInfo.city === this.acctInfo.city ? this.oldBankInfo.name : ""
                );
            }
        },
        "acctInfo.bankType"() {
            if (this.$refs.agreeRef) {
                this.$refs.agreeRef.index = 0;
            }
            if (this.acctInfo.bankType) {
                this.argtype = `${sceneEnum.addBankCard},${this.acctInfo.bankType}`;
            } else {
                this.argtype = sceneEnum.addBankCard;
            }
            this.resetProtocolState();
        },
        // 开关状态变化后，协议列表和勾选状态都要重新计算
        "acctInfo.addhkflag"() {
            this.resetProtocolState();
        },
        changeMobile(val) {
            if (!val) {
                this.acctInfo.newMobile = "";
            }
        }
    },
    // 初始化组件数据
    created() {
        const accountInfo = this.$cache.getParamValue("account_info");
        this.shieldBranchSelect = accountInfo.blockbranches;
        let recBankInfo = {};
        this.info = this.$cache.getUser();
        this.acctInfo.newMobile = this.info.mobileno;
        this.syncAddhkflagDefault();
        this.getBankCate();
        // 激活不支持校验交易密码
        if (this.bankCate != "") {
            this.$util.queryValidPwdTrdMethod(this.bankCate, (res) => {
                this.isPwdCheck = res;
            });
        }
        this.province = this.$cache.getDict("190021");

        recBankInfo = JSON.parse(sessionStorage.getItem("recBankInfo")) || {};
        if (recBankInfo.channelid) {
            this.bankInfo = recBankInfo;
            this.acctInfo.bankType = recBankInfo.channelid;
            this.syncAddhkflagDefault();
        }

        const _x = this.$route.query;
        // 初始化银行卡信息数据
        if (_x && _x.paycenterid) {
            const _p =
                this.province.find((item) => {
                    return item.subitemname === _x.depositprov || item.subitem === _x.depositprov;
                }) || {};
            this.oldBankInfo = {
                province: _p.subitem || "",
                city: _x.depositcity,
                name: _x.branchname
            };
            const _z = { oldBank: _x.depositcard };
            const { hkopenflag, addhkflag, ...routeAcctInfo } = _x;
            this.acctInfo = Object.assign(this.acctInfo, _z, routeAcctInfo);
            if (this.cate === "change") {
                this.acctInfo.bankcard = "";
            }
            this.emptyMobile = !_x.mobileno.trim();
            this.$set(this.acctInfo, "bankType", _x.paycenterid + "" + _x.bankcode);
            this.$set(this.acctInfo, "province", _p.subitem || "");
            this.bankInfo = {
                bankcode: _x.bankcode,
                channelid: _x.paycenterid + "" + _x.bankcode,
                paycenterid: _x.paycenterid,
                isneedbank: _x.isneedbank,
                identifytype: _x.identifytype,
                mobileno: _x.mobileno,
                paycentername: _x.paycentername,
                name: this.$util.getChannelName(_x)
            };
            this.syncAddhkflagDefault();
        }
    },
    destroyed() {
        sessionStorage.removeItem("recBankInfo");
    },
    methods: {
        clearOption() {
            if (this.$refs.autocomplete) {
                this.$refs.autocomplete.suggestions = [];
            }
        },
        // 页面初始化、切换银行或回填路由参数后，统一按当前展示条件设置 addhkflag 默认值
        syncAddhkflagDefault() {
            this.acctInfo.addhkflag = this.showTransferTradeSwitch ? "1" : "0";
        },
        // 协议集合变化后，强制重置阅读/勾选状态，避免沿用旧状态
        resetProtocolState() {
            this.protocol = false;
            this.protocolPassed = false;
        },
        shouldValidateBranch() {
            if (this.shieldBranchSelect) return false;
            return (this.bankInfo && this.bankInfo.isneedbank === "1") || this.cate === "modify";
        },
        validateBankname(rule, value, callback) {
            if (!this.shouldValidateBranch()) return callback();
            // 城市未选时，bankname 表单项不会展示；提交时允许跳过，由 city 规则兜底
            if (!this.acctInfo.city) return callback();
            if (!value) return callback(new Error("请选择开户行"));
            return this.$util.validateBankName(rule, value, callback);
        },
        checkMobile(rule, value, callback) {
            if (value === this.info.mobileno) {
                callback();
                return;
            }
            this.$util.validateMobile(rule, value, callback);
        },
        getVerifyCode(val) {
            this.dialogVisible = false;
            if (val) {
                this.getParams(val);
            }
        },
        /* 回调银行卡信息 */
        getBankMsg(val) {
            this.bankVisible = false;
            // this.acctInfo.bankcard = "";
            this.acctInfo.province = "";
            this.acctInfo.city = "";
            this.acctInfo.bankname = "";
            if (val && val.bank) {
                this.bankInfo = val.bank;
                this.acctInfo.bankType = this.bankInfo.channelid;
                this.syncAddhkflagDefault();
            }
        },
        agreePro(val) {
            this.protocol = false;
            if (!val) return;
            // 短信已发送（locked=true）说明是 submitInfo 触发的二次确认，直接弹验证码弹窗
            if (this.locked) {
                if (this.bankInfo.identifytype === "1" && this.cate !== "modify") {
                    this.mobileVisible = true;
                } else {
                    this.getParams();
                }
            } else {
                // 短信未发送，仅记录协议已同意，由「下一步」按钮触发后续流程
                this.protocolPassed = true;
                if (this.timer) clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    this.getParams("");
                }, 1000);
            }
        },
        validateVerifyCode(rule, value, callback) {
            if (this.isCheckVerifyCode) {
                this.$util.validateVerifyCode(rule, value, callback);
            } else {
                callback();
            }
        },
        // 手机发送短信
        mobileCheck() {
            this.isCheckVerifyCode = false;
            this.$refs["acctInfo"].validate((valid) => {
                this.isCheckVerifyCode = true;
                if (valid) {
                    // 先检查协议是否已阅读同意
                    if (!this.protocolPassed) {
                        if (this.acctInfo.bankType) {
                            this.argtype = `${sceneEnum.addBankCard},${this.acctInfo.bankType}`;
                        } else {
                            this.argtype = sceneEnum.addBankCard;
                        }
                        // 触发协议阅读流程，阅读完成后 agreePro 会设置 protocolPassed = true
                        this.protocol = true;
                        return;
                    }
                    // 协议已同意，走正常流程：sendBank 内部调用 /api/authSend 发短信，再弹验证码弹窗
                    if (this.timer) clearTimeout(this.timer);
                    this.timer = setTimeout(async () => {
                        this.getParams("");
                    }, 1000);
                } else {
                    this.$errorScroll();
                }
            });
        },
        getMobileCode(val) {
            this.mobileVisible = false;
            if (val) {
                this.checkVerifyCode(val);
            } else {
                this.locked = false;
            }
            return false;
        },
        async getParams(verifyCode) {
            let params = {};
            if (this.acctInfo.tradepwd) {
                params.tradepassword = this.$util.enc(this.acctInfo.tradepwd);
            }
            if (this.cate === "sign" || this.cate === "unsign" || this.cate === "active") {
                this.cateText =
                    this.cate === "sign" ? "签约" : this.cate === "unsign" ? "解约" : "激活";
                let _x = {};
                if (this.cate === "active") {
                    _x.biztype = "02";
                    _x.paychannel = this.bankInfo.paycenterid;
                    _x.channelid = this.bankInfo.channelid;
                    _x.channelname = this.bankInfo.channelname;
                    _x.bankcardid = this.acctInfo.bankcardid;
                    _x.bankcode = this.bankInfo.bankcode;
                    _x.certificatetype = this.$cache.getUser().certificatetype;
                    if (this.bankInfo.identifytype === "2") {
                        this.randomToken = this.$util.generateRandomNumber();
                        _x.pagecallbackurl =
                            window.location.origin +
                            "" +
                            "/sale-mid-ump/bank/redirect?token=" +
                            this.randomToken;
                        // 建行网联的回调地址配置在银行那边，需要单独处理
                        if (this.bankInfo.paycenterid == "0105") {
                            _x.pagecallbackurl =
                                window.location.origin + "" + "/sale-mid-ump/bank/ccb";
                        }
                        params.signtype = "0";
                    }
                }
                this.getMobile(_x);
                if (this.$cache.getIsEncrypted()) {
                    _x.en_certificateno = this.$cache.getUser().en_certificateno;
                    _x.en_depositname = this.$cache.getUser().en_custname;
                } else {
                    _x.certificateno = this.$cache.getUser().certificateno;
                    _x.depositname = this.$cache.getUser().custname;
                }
                params = Object.assign({}, params, _x);
            } else {
                let branchcode = "";
                // 获取联行号
                const _y = this.branchList.filter((branch) => {
                    return branch.branchname === this.acctInfo.bankname;
                });
                if (_y && _y[0]) {
                    branchcode = _y[0].exchangecode;
                }
                const _bankInfo = {
                    branchinterbankcode: branchcode,
                    branchnum: branchcode,
                    depositprov: this.acctInfo.province,
                    depositcity: this.acctInfo.city,
                    branchname: this.acctInfo.bankname,
                    bankname: this.acctInfo.bankname,
                    verifycode: verifyCode || ""
                };
                params = Object.assign({}, params, _bankInfo);
                // 添加额外参数
                if (this.$cache.getIsEncrypted()) {
                    params.en_certificateno = this.$cache.getUser().en_certificateno;
                    params.en_depositname = this.$cache.getUser().en_custname;
                } else {
                    params.certificateno = this.$cache.getUser().certificateno;
                    params.depositname = this.$cache.getUser().custname;
                }
                if (this.cate === "add") {
                    this.cateText = "新增";
                    params.biztype = "02";
                    params.certificatetype = this.$cache.getUser().certificatetype;
                    params.addhkflag = this.acctInfo.addhkflag;
                    params.channelid = this.bankInfo.channelid;
                    params.channelname = this.bankInfo.channelname;
                    params.depositcard = this.acctInfo.bankcard;
                    params.bankcode = this.bankInfo.bankcode;
                    params.paychannel = this.bankInfo.paycenterid;
                    if (this.bankInfo.identifytype === "2") {
                        this.randomToken = this.$util.generateRandomNumber();
                        params.pagecallbackurl =
                            window.location.origin +
                            "" +
                            "/sale-mid-ump/bank/redirect?token=" +
                            this.randomToken;
                        // 建行网联的回调地址配置在银行那边，需要单独处理
                        if (this.bankInfo.paycenterid == "0105") {
                            params.pagecallbackurl =
                                window.location.origin + "" + "/sale-mid-ump/bank/ccb";
                        }
                        params.signtype = "0";
                    }
                } else if (this.cate === "modify") {
                    this.cateText = "修改";
                    params.paychannel = this.bankInfo.paycenterid;
                    params.transactionaccountid = this.acctInfo.transactionaccountid;
                    this.sendBank(params);
                    return false;
                }
                this.getMobile(params);
                if (this.cate === "change") {
                    this.cateText = "更换";
                    const _x = {
                        bankcard: this.acctInfo.bankcard,
                        bankcardid: this.acctInfo.bankcardid
                    };
                    params = Object.assign({}, params, _x);
                }
            }
            this.sendBank(params);
        },
        async sendBank(data) {
            const _way = this.cate === "modify" ? "PUT" : "POST";
            if (
                _way === "PUT" &&
                this.acctInfo.newMobile === "" &&
                (this.$route.query.depositcity.trim() !== ""
                    ? this.acctInfo.city === this.$route.query.depositcity.trim()
                    : true) &&
                (this.$route.query.branchname.trim() !== ""
                    ? this.acctInfo.bankname === this.$route.query.branchname.trim()
                    : true)
            ) {
                this.$message({
                    type: "warning",
                    message: "未做任何修改，请先做修改再进行提交"
                });
                return false;
            }
            if (this.cate === "modify") {
                const res = await userApi.combBankCardInfoUpdate(
                    data,
                    this.$cache.getIsEncrypted() ||
                        this.acctInfo.newMobile === this.acctInfo.mobileno
                );
                if (res.code == "0") {
                    this.getSuccessInfo();
                }
            } else {
                if (this.bankInfo.paycenterid === "0001" || this.bankInfo.paycenterid === "1000") {
                    data.bankcardmobile = this.acctInfo.newMobile;
                    const res = await userApi.combBankCardCreate(
                        data,
                        this.$cache.getIsEncrypted() ||
                            this.acctInfo.newMobile === this.acctInfo.mobileno
                    );
                    if (res.code == "0") {
                        this.getSuccessInfo();
                    }
                } else if (this.bankInfo.identifytype === "1") {
                    data.verifytype = "1";
                    const res = await userApi.sendBindCardSms(
                        data,
                        this.$cache.getIsEncrypted() ||
                            this.acctInfo.newMobile === this.acctInfo.mobileno
                    );
                    if (res.code == "0") {
                        if (this.cate === "unsign") {
                            this.getSuccessInfo();
                        } else {
                            let result = res.data;
                            if (result && result.comtype && result.comtype === "socket") {
                                if (this.cate === "add") {
                                    const res = await userApi.addBankCard(
                                        data,
                                        this.acctInfo.newMobile === this.acctInfo.mobileno
                                    );
                                    if (res.code == "0") {
                                        this.getSuccessInfo();
                                    }
                                } else if (this.cate === "active") {
                                    const res = await userApi.combUpdateBankcardAuth(
                                        data,
                                        this.$cache.getIsEncrypted() ||
                                            this.acctInfo.newMobile === this.acctInfo.mobileno
                                    );
                                    if (res.code == "0") {
                                        this.getSuccessInfo();
                                    }
                                } else {
                                    this.getSuccessInfo();
                                }
                            } else {
                                this.time = res.data.sendperiod;
                                this.locked = true;
                                this.$util.btnDisabled(this);
                                if (this.protocolPassed) {
                                    this.mobileVisible = true;
                                } else {
                                    this.submitInfo("acctInfo");
                                }
                            }
                        }
                    }
                } else if (this.bankInfo.identifytype === "2") {
                    data.verifytype = "0";
                    const res = await userApi.sendBindCardSms(
                        data,
                        this.$cache.getIsEncrypted() ||
                            this.acctInfo.newMobile === this.acctInfo.mobileno
                    );
                    if (res.data) {
                        if (this.cate === "unsign") {
                            this.getSuccessInfo();
                        } else {
                            const pageUrl = res.data.bankgateurl ? res.data.bankgateurl : "";
                            let pageParam = res.data.bankgateparam ? res.data.bankgateparam : {};
                            if (pageParam) {
                                pageParam = JSON.parse(pageParam);
                            }
                            const bankgateserialno = res.data.bankgateserialno;
                            const reqMethod = res.data.method;
                            this.$util.openPostWindow(pageUrl, pageParam, reqMethod, "_blank");
                            let isDecryptObj = {};
                            if (this.$cache.getIsEncrypted()) {
                                isDecryptObj.en_certificateno =
                                    this.$cache.getUser().en_certificateno;
                                isDecryptObj.en_depositname = this.$cache.getUser().en_custname;
                            } else {
                                isDecryptObj.certificateno = this.$cache.getUser().certificateno;
                                isDecryptObj.depositname = this.$cache.getUser().custname;
                            }
                            const params = {
                                ...isDecryptObj,
                                token: this.randomToken,
                                certificatetype: this.$cache.getUser().certificatetype,
                                bankcode: this.bankInfo.bankcode,
                                depositcard: this.acctInfo.bankcard,
                                paychannel: this.bankInfo.paycenterid,
                                bankgateserialno: bankgateserialno,
                                signtype: "0"
                            };
                            this.getMobile(params);
                            if (this.acctInfo.bankcardid) {
                                params.bankcardid = this.acctInfo.bankcardid;
                            }
                            this.$util.confirmBankAuth(
                                this,
                                params,
                                "BankPageAuthentication",
                                async () => {
                                    if (this.cate === "add") {
                                        const res = await userApi.addBankCard(
                                            data,
                                            this.acctInfo.newMobile === this.acctInfo.mobileno
                                        );
                                        if (res.code == "0") {
                                            this.getSuccessInfo();
                                        }
                                    } else if (this.cate === "active") {
                                        const res = await userApi.combUpdateBankcardAuth(
                                            data,
                                            this.$cache.getIsEncrypted() ||
                                                this.acctInfo.newMobile === this.acctInfo.mobileno
                                        );
                                        if (res.code == "0") {
                                            this.getSuccessInfo();
                                        }
                                    }
                                }
                            );
                        }
                    }
                }
            }
        },
        // 处理银行卡操作成功信息
        getSuccessInfo() {
            // 用户首次增卡更新
            if (this.fn) {
                const info = this.$cache.getUser();
                info.totalcardnum = Number(info.totalcardnum) + 1;
                this.$store.dispatch("setInfo", info).then(() => {
                    this.$emit("fn-back", true);
                });
            } else {
                // 绑定交易账户后更新
                this.$cache.refreshUser();
                this.result.msg = "您的银行卡已" + this.cateText + "成功！";
                const _num = this.acctInfo.bankcard
                    ? this.acctInfo.bankcard
                    : this.acctInfo.oldBank;
                this.result.btnMsg =
                    "您" +
                    this.cateText +
                    "的银行卡为：" +
                    this.$util.getChannelName(this.bankInfo) +
                    "尾号[" +
                    _num.substr(_num.length - 4, 4) +
                    "]";
                this.checked = true;
            }
        },
        // 生成搜索列表
        querySearch(queryString, cb) {
            let cityObj = this.city.find((item) => {
                return item.cityid === this.acctInfo.city;
            });
            this.acctInfo.cityName = cityObj.cityname;
            this.$util.querySearch(this, queryString, this.bankInfo.bankcode, cb);
        },
        checkBankName() {
            const _y = this.branchList.filter((branch) => {
                return branch.branchname === this.acctInfo.bankname;
            });
            if (_y.length === 0) {
                this.$set(this.acctInfo, "bankname", "");
            }
        },
        submitInfo(formName) {
            const _this = this;
            _this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.bankInfo.identifytype === "1" && this.cate !== "modify") {
                        if (!this.locked) {
                            this.$message({
                                type: "warning",
                                message: "请先发送手机短信验证码"
                            });
                            return false;
                        }
                    }
                    if (this.acctInfo.bankType) {
                        this.argtype = `${sceneEnum.addBankCard},${this.acctInfo.bankType}`;
                    } else {
                        this.argtype = sceneEnum.addBankCard;
                    }
                    this.protocol = true;
                } else {
                    this.$errorScroll();
                }
            });
        },
        /* 校验手机验证码 */
        async checkVerifyCode(val) {
            let checkBindCardSmsParams = {
                biztype: "02",
                smscode: val
            };
            this.getMobile(checkBindCardSmsParams);
            const res = await userApi.checkBindCardSms(
                checkBindCardSmsParams,
                this.acctInfo.newMobile === this.acctInfo.mobileno
            );
            if (res.code == "0") {
                if (this.cate === "add") {
                    let branchcode = "";
                    // 获取联行号
                    const _y = this.branchList.filter((branch) => {
                        return branch.branchname === this.acctInfo.bankname;
                    });
                    if (_y && _y[0]) {
                        branchcode = _y[0].exchangecode;
                    }
                    let isDecryptObj = {};
                    if (this.$cache.getIsEncrypted()) {
                        isDecryptObj.en_certificateno = this.$cache.getUser().en_certificateno;
                    } else {
                        isDecryptObj.certificateno = this.$cache.getUser().certificateno;
                    }
                    let addBankCardParams = {
                        ...isDecryptObj,
                        certificatetype: this.$cache.getUser().certificatetype,
                        tradepassword: this.$util.enc(this.acctInfo.tradepwd),
                        depositprov: this.acctInfo.province,
                        depositcity: this.acctInfo.city,
                        bankname: this.acctInfo.bankname,
                        branchinterbankcode: branchcode,
                        addhkflag: this.acctInfo.addhkflag,
                        bankcode: this.bankInfo.bankcode
                    };
                    this.getMobile(addBankCardParams);
                    const addRes = await userApi.addBankCard(
                        addBankCardParams,
                        this.$cache.getIsEncrypted() ||
                            this.acctInfo.newMobile === this.acctInfo.mobileno
                    );
                    if (addRes.code == "0") {
                        this.getSuccessInfo();
                    }
                } else if (this.cate === "active") {
                    let isDecryptObj = {};
                    if (this.$cache.getIsEncrypted()) {
                        isDecryptObj.en_certificateno = this.$cache.getUser().en_certificateno;
                    } else {
                        isDecryptObj.certificateno = this.$cache.getUser().certificateno;
                    }
                    const upDateRes = await userApi.combUpdateBankcardAuth(
                        {
                            ...isDecryptObj,
                            bankcardid: this.acctInfo.bankcardid,
                            paychannel: this.bankInfo.paycenterid,
                            bankcode: this.bankInfo.bankcode,
                            certificatetype: this.$cache.getUser().certificatetype
                        },
                        this.$cache.getIsEncrypted() ||
                            this.acctInfo.newMobile === this.acctInfo.mobileno
                    );
                    if (upDateRes.code == "0") {
                        this.getSuccessInfo();
                    }
                } else {
                    this.getSuccessInfo();
                }
            }

            // const _this = this;
            // this.$util
            //     .request(
            //         "acct/" + this.cate + "card/authcheckmsg",
            //         { verifycode: val },
            //         "POST"
            //     )
            //     .then((res) => {
            //         if (res.data) {
            //             _this.getSuccessInfo();
            //         }
            //     });
        },
        getBankCate() {
            switch (this.cate) {
                case "add":
                    this.bankCate = "0A3";
                    break;
                case "sign":
                    this.bankCate = "0C5";
                    break;
                case "unsign":
                    this.bankCate = "0C6";
                    break;
                case "change":
                    this.bankCate = "0A7";
                    break;
                case "modify":
                    this.bankCate = "0A8";
                    break;
                default:
                    break;
            }
        },
        changeInputMode(mode) {
            this.inputMode = mode;
        },
        getMobile(obj) {
            let mobile = this.cate === "add" ? this.info.mobileno : this.bankInfo.mobileno;
            // eslint-disable-next-line camelcase
            let en_mobileno =
                this.cate === "add" ? this.info.en_mobileno : this.bankInfo.en_mobileno;
            if (this.acctInfo.newMobile === mobile) {
                // eslint-disable-next-line camelcase
                obj["en_mobileno"] = en_mobileno;
            } else {
                obj["mobileno"] = this.acctInfo.newMobile;
            }
        }
    }
};
</script>
<style lang="scss">
/* 用户持有银行卡信息 */
.comp-bank-operation {
    margin-bottom: 100px;
    .bank.form-text {
        .bank-msg .bank-img-sel {
            padding: 0;
            margin: 1px 0;
        }
    }
    .form-text-bank {
        .el-form-item__content .el-form-item__error {
            position: absolute;
            left: 0;
            bottom: -18px;
        }
    }
    .other-prompt {
        font-size: $f14;
        margin-left: 20px;
        color: $text-color1;
        vertical-align: middle;
        display: inline-block;
        i {
            color: var(--color-primary);
            margin-right: 5px;
            vertical-align: middle;
        }
    }
    .el-button.info-btn {
        border: none;
        padding: 10px;
        &:hover,
        &:focus {
            background-color: transparent;
        }
    }
    .el-form-item__label {
        font-size: 14px !important;
        font-weight: normal;
        color: #333333 !important;
    }
    .text-con {
        font-size: 16px;
        font-weight: normal;
        color: #333333;
    }
    .transfer-trade-item {
        margin-bottom: 22px;
    }
    .transferTradeSwitch {
        width: 416px;
        display: flex;
        justify-content: flex-end;
        text-align: right;
    }
    .transferTradeSwitch-content {
        margin-left: 416px !important;
    }
    .question-trigger {
        padding: 0;
        width: 18px;
        height: 40px;
        background: transparent !important;
        &:hover {
            background: transparent !important;
        }
    }
    .question-icon {
        font-size: 18px;
        color: #999999;
    }
    .transferTradeSwitch-switch {
        padding-left: 10px;
    }
    .warm-tip {
        font-size: 14px;
        color: var(--color-primary);
        i {
            margin-right: 5px;
            vertical-align: middle;
        }
    }
    .next-btn {
        width: 180px;
        height: 42px;
        line-height: 42px;
        border-radius: 2px;
        background: var(--color-primary);
        border: none;
        font-size: 16px;
        font-weight: 500;
        color: #ffffff;
        cursor: pointer;
    }
    .append-info {
        position: absolute;
        left: 412px;
        top: 0px;
    }
}
</style>
